export const SELECTED_TEACHERS_STORAGE_KEY = 'selectedTeachers';
export const SELECTED_TEACHER_PREFERENCE_STORAGE_KEY = 'selectedTeacherPreference';
export const PENDING_TEACHER_SELECTION_STORAGE_KEY = 'pendingTeacherSelectionPurchase';

const normalizeStudentUserId = (studentUserId?: string | null) => String(studentUserId || '').trim();

export const getStudentScopedStorageKey = (baseKey: string, studentUserId?: string | null) => {
  const normalizedStudentUserId = normalizeStudentUserId(studentUserId);
  return normalizedStudentUserId ? `${baseKey}:${normalizedStudentUserId}` : '';
};

export const getStudentScopedStorageItem = (baseKey: string, studentUserId?: string | null) => {
  const storageKey = getStudentScopedStorageKey(baseKey, studentUserId);
  return storageKey ? localStorage.getItem(storageKey) : null;
};

export const setStudentScopedStorageItem = (
  baseKey: string,
  studentUserId: string | null | undefined,
  value: string,
) => {
  const storageKey = getStudentScopedStorageKey(baseKey, studentUserId);
  if (!storageKey) return;
  localStorage.setItem(storageKey, value);
};

export const removeStudentScopedStorageItem = (baseKey: string, studentUserId?: string | null) => {
  const storageKey = getStudentScopedStorageKey(baseKey, studentUserId);
  if (!storageKey) return;
  localStorage.removeItem(storageKey);
};
